const axios = require('axios');

export default class {
  textStatus () {
    return 'Discando...';
  }

  startCall (call) {
    Bus.$emit(`startCall-${call.data.hash}`);

    axios.post('https://api.api4com.com/api/v1/calls', {
      caller: call.caller,
      called: call.called,
      extension: call.caller,
      metadata: {
        hash: call.data.hash,
        token: call.data.token,
        user: call.data.user
      },
    }, {
      params: {
        access_token: call.token,
      },
    })
      .then((response) => {
        const status = response.data.data.message.slice(0, 4);

        if (status === '+OK ') {
          Alert.success('Discando...');
        }

        if (status === '-ERR') {
          Alert.error('Não foi possível efetuar a chamada. Verifique seu ramal.');
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data);

          switch (error.response.status) {
            case 400:
              Alert.error('Não foi possível efetuar a chamada. Verifique seu ramal.');
              break;

            case 401:
              Alert.error('Não foi possível autenticar. Verifique suas configurações.');
              break;

            default:
              Alert.error('Não foi possível efetuar a chamada. Verifique suas configurações.');
              break;
          }
        }
      })
      .finally(() => {
        Bus.$emit(`endCall-${call.data.hash}`);
      });
  }

  endCall () {
  }
}
